import React from 'react';
import { Button } from 'modules/cxi/components/button';
import { RHP } from 'providers';
import { UserCompanyLogo } from 'core/components/company/companyLogo';
import { UserAvatar } from 'core/components/user';
import { useUser } from 'hooks';
import { useTranslation } from 'react-i18next';
import * as Styled from './styledAboutUser';

export const AboutUser = props => {
    const user = useUser();
    const { t } = useTranslation('glossary');
    const { useRankingCorporate } = props;
    const { vars } = useRankingCorporate;
    const { companyDetails } = vars;

    return (
        <Styled.About>
            <Styled.Wrapper className="user">
                <Styled.UserProfile>{t('yourProfile')}</Styled.UserProfile>
                <Styled.AboutBody className="user">
                    <div className="user">
                        <Styled.UserLogo>
                            <UserAvatar />
                            <UserCompanyLogo />
                        </Styled.UserLogo>

                        <div className="infos">
                            <span className="name">{user.fullName}</span>
                            <span className="comp">
                                <strong style={{ fontWeight: 500 }}>{companyDetails.name}</strong> -{' '}
                                {user.position}
                            </span>
                            <span className="post">{user.email}</span>
                        </div>
                    </div>
                    <Button
                        className="about-button"
                        variant="blue"
                        size="medium"
                        onClick={() => RHP.push('/profile')}
                    >
                        <span className="text">{t('glossary:edit')}</span>
                    </Button>
                </Styled.AboutBody>
            </Styled.Wrapper>
        </Styled.About>
    );
};
